import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from 'src/app/layout/layout.component';
import { AuthenticationGuardService } from 'src/app/services/authentication-guard.service';
import { OrderComponent } from './order.component';
import { ListOrderComponent } from './list-order/list-order.component';
import { NewOrderComponent } from './new-order/new-order.component';
import { ViewOrderComponent } from './view-order/view-order.component';
import { RoleGuard } from 'src/app/guards/role.guard';
import { EUserRole } from 'src/app/utils';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'orders',
        component: OrderComponent,
        canActivate: [AuthenticationGuardService],
        children: [
          { path: '', component: ListOrderComponent },
          {
            path: ':point-of-sale-id/new',
            component: NewOrderComponent,
            canActivate: [AuthenticationGuardService, RoleGuard],
            data: {
              roles: [EUserRole.ADMIN, EUserRole.PRE_COMMANDER, EUserRole.SUPERVISOR, EUserRole.ZONE_CHIEF, EUserRole.COUNTRY_MANAGER],
            },
          },
          {
            path: ':point-of-sale-id',
            component: ViewOrderComponent,
            canActivate: [AuthenticationGuardService, RoleGuard],
            data: {
              roles: [EUserRole.ADMIN, EUserRole.PRE_COMMANDER, EUserRole.SUPERVISOR, EUserRole.ZONE_CHIEF, EUserRole.COUNTRY_MANAGER],
            },
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class OrderRoutingModule {}
